var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable react/jsx-props-no-spreading */
import { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { $api } from 'shared/api/api';
import { BlockLoader } from 'shared/ui/BlockLoader';
import StatisticTable from 'shared/ui/Statistic/Table';
import { Title } from 'shared/ui/Title';
import { Wrapper } from 'shared/ui/Wrapper';
import { Button, ButtonSize } from 'shared/ui/Button';
import Eye from 'shared/assets/icons/eye.svg';
import cls from 'shared/ui/Statistic/Statistic.module.scss';
import ReactPaginate from 'react-paginate';
import { useWindowResolution } from 'shared/lib/hooks/useWindowResolution';
import { Doughnut } from 'react-chartjs-2';
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js';
import { SimpleSelect } from 'shared/ui/SimpleSelect';
import { useDispatch, useSelector } from 'react-redux';
import InputMask from 'react-input-mask';
import lessonPageStyles from './LessonPage.module.scss';
import { getLessonStatisticData, getLessonStatisticFilter } from './model/selectors/getLessonStatistic';
import { lessonStatisticActions } from './model/slice/LessonStatisticSlice';
import { getLessonStatistic } from './model/services/getLessonStatistic';
ChartJS.register(ArcElement, Tooltip, Legend);
function hideLastNamesInStatistic(data) {
    if (!data)
        return data;
    var formattedData = JSON.parse(JSON.stringify(data));
    var newStatisticsWithHiddenNames = Object.values(formattedData.data.statistic).map(function (statistic) {
        var hiddenFio = statistic.fio;
        var hiddenFioParts = hiddenFio.split(' ');
        var hiddenFioProcessed = hiddenFioParts.map(function (part, index) {
            if (part.length <= 1) {
                return part;
            }
            if (index > 0)
                return part;
            return part[0] + '*'.repeat(part.length - 1);
        }).join(' ');
        return __assign(__assign({}, statistic), { fio: hiddenFioProcessed });
    });
    formattedData.data.statistic = newStatisticsWithHiddenNames;
    return formattedData;
}
function filterStatistics(statistics, statistciFilter) {
    return __awaiter(this, void 0, void 0, function () {
        var lesssonsFromStore, lessonStatistics, newArray, newArray, newArray, newArray, inputDate_1, newArray, newArray;
        return __generator(this, function (_a) {
            lesssonsFromStore = JSON.parse(JSON.stringify(statistics));
            if (lesssonsFromStore) {
                lessonStatistics = lesssonsFromStore.data.statistic;
                if (statistciFilter.groupFilter) {
                    newArray = lessonStatistics.filter(function (item) { return item.club.id === +statistciFilter.groupFilter; });
                    lesssonsFromStore.data.statistic = newArray;
                }
                if (statistciFilter.IDFilter) {
                    newArray = lessonStatistics.filter(function (item) { return item.bp_id === +statistciFilter.IDFilter; });
                    lesssonsFromStore.data.statistic = newArray;
                }
                if (statistciFilter.userNameFilter) {
                    newArray = lessonStatistics.filter(function (item) { return item.fio.includes(statistciFilter.userNameFilter); });
                    lesssonsFromStore.data.statistic = newArray;
                }
                if (statistciFilter.currentFilter) {
                    newArray = lessonStatistics.filter(function (item) { return item.current === +statistciFilter.currentFilter; });
                    lesssonsFromStore.data.statistic = newArray;
                }
                if (statistciFilter.dateFilter) {
                    inputDate_1 = statistciFilter.dateFilter;
                    newArray = lessonStatistics.filter(function (item) {
                        var _a, _b, _c;
                        return (_c = (_b = (_a = item
                            .finished_at
                            .split(' ')[0]) === null || _a === void 0 ? void 0 : _a.split('-')) === null || _b === void 0 ? void 0 : _b.reverse()) === null || _c === void 0 ? void 0 : _c.join('').includes(inputDate_1);
                    });
                    lesssonsFromStore.data.statistic = newArray;
                }
                if (statistciFilter.checkedFilter) {
                    newArray = lessonStatistics.filter(function (item) { return item.verified === +statistciFilter.checkedFilter; });
                    lesssonsFromStore.data.statistic = newArray;
                }
                return [2 /*return*/, lesssonsFromStore];
            }
            return [2 /*return*/, statistics];
        });
    });
}
var COLUMNS = {
    pos: '№',
    club: 'Группа',
    fio: 'Пользователь',
    bp_id: 'ID Платформы',
    name: 'Урок',
    publish: 'Опубликован',
    current: 'Последнее',
    progress: 'Прогресс',
    score: 'Баллы',
    date: 'Дата прохождения',
    verified: 'Проверено',
};
export default function StatisticLessonPage() {
    var _this = this;
    var lessonId = useParams().lessonId;
    var searchParams = useSearchParams()[0];
    var LessonStatisticDataFromStore = useSelector(getLessonStatisticData);
    var _a = useState(null), lesson = _a[0], setLesson = _a[1];
    var navigate = useNavigate();
    var lessonName = searchParams.get('name');
    var windowResolution = useWindowResolution();
    var statistciFilter = useSelector(getLessonStatisticFilter);
    var dispatch = useDispatch();
    // Загрузка статистики сервера и обновление стора
    useEffect(function () {
        dispatch(getLessonStatistic({ lessonId: lessonId, page: 1, limit: 100 }));
    }, []);
    var booleanFilterOptions = [
        {
            label: 'Да',
            value: '1',
        },
        {
            label: 'Нет',
            value: '0',
        },
    ];
    var checkedFilterOptions = [
        {
            label: 'Да',
            value: '1',
        },
        {
            label: 'Нет',
            value: '0',
        },
        {
            label: 'Не требуется',
            value: '2',
        },
    ];
    // Фильтры
    var submitFilter = function (filterField, value) {
        switch (filterField) {
            case 'group':
                dispatch(lessonStatisticActions.setGroupFilter(value));
                break;
            case 'id':
                dispatch(lessonStatisticActions.setIdFilter(value));
                break;
            case 'lesson':
                dispatch(lessonStatisticActions.setLessonFilter(value));
                break;
            case 'published':
                dispatch(lessonStatisticActions.setPublishedFilter(value));
                break;
            case 'current':
                dispatch(lessonStatisticActions.setCurrentFilter(value));
                break;
            case 'date':
                dispatch(lessonStatisticActions.setDateFilter(value));
                break;
            case 'checked':
                dispatch(lessonStatisticActions.setCheckedFilter(value));
                break;
            case 'username':
                dispatch(lessonStatisticActions.setUserNameFilter(value));
                break;
            default:
                break;
        }
    };
    useEffect(function () {
        var loadData = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!statistciFilter.lessonFilter) return [3 /*break*/, 2];
                        // Если lessonFilter установлен, загружаем данные для указанного урока
                        return [4 /*yield*/, dispatch(getLessonStatistic({ lessonId: statistciFilter.lessonFilter, page: 1, limit: 100 }))];
                    case 1:
                        // Если lessonFilter установлен, загружаем данные для указанного урока
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: 
                    // Если lessonFilter очищен, загружаем данные с дефолтными значениями
                    return [4 /*yield*/, dispatch(getLessonStatistic({ lessonId: lessonId, page: 1, limit: 100 }))];
                    case 3:
                        // Если lessonFilter очищен, загружаем данные с дефолтными значениями
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        if (statistciFilter.publishedFilter) {
            dispatch(getLessonStatistic({
                lessonId: statistciFilter.lessonFilter === '' ? lessonId : statistciFilter.lessonFilter,
                publish: +statistciFilter.publishedFilter,
                page: 1,
                limit: 100,
            }));
        }
        else {
            dispatch(getLessonStatistic({
                lessonId: statistciFilter.lessonFilter === '' ? lessonId : statistciFilter.lessonFilter,
                publish: 1,
                page: 1,
                limit: 100,
            }));
        }
        loadData();
    }, [statistciFilter.lessonFilter, statistciFilter.publishedFilter]);
    // Фильтрация
    useEffect(function () {
        var filterData = function () { return __awaiter(_this, void 0, void 0, function () {
            var filteredStatistics, statisticsWithHiddenLastNames;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, filterStatistics(LessonStatisticDataFromStore, statistciFilter)];
                    case 1:
                        filteredStatistics = _a.sent();
                        statisticsWithHiddenLastNames = hideLastNamesInStatistic(filteredStatistics);
                        setLesson(statisticsWithHiddenLastNames);
                        return [2 /*return*/];
                }
            });
        }); };
        filterData();
    }, [statistciFilter, LessonStatisticDataFromStore]);
    // Данные для круговой диаграммы
    var DoughnutData = {
        legend: {
            display: false,
        },
        datasets: [
            {
                data: [50, 100],
                backgroundColor: ['rgba(33, 79, 226, 0.20)', '#214FE2'],
                borderColor: ['rgba(33, 79, 226, 0.20)', '#214FE2'],
                borderWidth: 1,
            },
        ],
    };
    // Опции круговой диаграммы
    var DoughnutOptions = {
        cutout: '65%',
    };
    return (_jsxs(Wrapper, { className: cls.wrapper, children: [_jsxs(Title, { className: lessonPageStyles.title, children: ["\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u043F\u043E \u0443\u0440\u043E\u043A\u0443 ", _jsx("br", {}), " ", lessonName !== null ? "\"".concat(lessonName, "\"") : '', " "] }), lesson === null ? _jsx(BlockLoader, {})
                : (_jsxs(_Fragment, { children: [_jsxs("div", { className: cls.form, children: [_jsx(SimpleSelect, { className: cls.element, options: lesson.data.filters.clubs.map(function (_a) {
                                        var id = _a.id, name = _a.name;
                                        return ({
                                            label: name,
                                            value: JSON.stringify(id),
                                        });
                                    }), placeholder: "\u0413\u0440\u0443\u043F\u043F\u0430", onSelectValue: function (value) { return submitFilter('group', value === null || value === void 0 ? void 0 : value.value); } }), _jsx("input", { className: cls.search, type: "text", placeholder: "\u0418\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F", onChange: function (e) { return submitFilter('username', e.target.value); } }), _jsx("input", { className: cls.search, placeholder: "ID \u041F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B", onChange: function (e) { return submitFilter('id', e.target.value); } }), _jsx(SimpleSelect, { className: cls.element, options: lesson.data.filters.lessons.map(function (_a) {
                                        var id = _a.id, name = _a.name;
                                        return ({
                                            label: name,
                                            value: JSON.stringify(id),
                                        });
                                    }), placeholder: "\u0423\u0440\u043E\u043A", onSelectValue: function (value) { return submitFilter('lesson', value === null || value === void 0 ? void 0 : value.value); } }), _jsx(SimpleSelect, { className: cls.element, options: booleanFilterOptions, placeholder: "\u041E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D", onSelectValue: function (value) { return submitFilter('published', value === null || value === void 0 ? void 0 : value.value); } }), _jsx(SimpleSelect, { className: cls.element, options: booleanFilterOptions, placeholder: "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0435", onSelectValue: function (value) { return submitFilter('current', value === null || value === void 0 ? void 0 : value.value); } }), _jsx(InputMask, { className: cls.search, mask: "99/99/9999", placeholder: "\u0434\u0434/\u043C\u043C/\u0433\u0433\u0433\u0433", alwaysShowMask: false, onChange: function (e) { return submitFilter('date', e.target.value.replace(/\D/g, '')); } }), _jsx(SimpleSelect, { className: cls.element, options: checkedFilterOptions, placeholder: "\u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043E", onSelectValue: function (value) { return submitFilter('checked', value === null || value === void 0 ? void 0 : value.value); } })] }), _jsx(StatisticTable, { columns: COLUMNS, children: lesson.data.statistic.map(function (item, index) {
                                var _a, _b, _c, _d, _e, _f, _g, _h;
                                return (windowResolution.width > 766 ? (_jsx("tbody", { children: _jsxs("tr", { className: lessonPageStyles.tr, children: [_jsx("td", { children: index + 1 }), _jsx("td", { children: item.club.name }), _jsx("td", { children: item.fio }), _jsx("td", { children: item.bp_id }), _jsx("td", { children: lesson.data.lesson.name }), _jsx("td", { children: lesson.data.lesson.publish == 1 ? 'Да' : 'Нет' }), _jsx("td", { children: item.current == 1 ? 'Да' : 'Нет' }), _jsx("td", { children: item.progress }), _jsx("td", { children: item.score }), _jsx("td", { children: (_d = (_c = (_b = (_a = item.finished_at) === null || _a === void 0 ? void 0 : _a.split(' ')[0]) === null || _b === void 0 ? void 0 : _b.split('-')) === null || _c === void 0 ? void 0 : _c.reverse()) === null || _d === void 0 ? void 0 : _d.join('.') }), _jsx("td", { children: item.verified == 1 ? 'Да' : 'Нет' }), _jsx("td", { className: "".concat(lessonPageStyles.statisticButton), children: _jsx(Button, { className: lessonPageStyles.eyeButton, size: ButtonSize.S, icon: _jsx(Eye, {}), onClick: function () {
                                                        navigate("/statistic/lesson/".concat(lessonId, "/steps?user=").concat((item.user_email), "&lesson=").concat(lesson.data.lesson.name));
                                                    } }) })] }) }, index)) : (_jsxs("div", { className: lessonPageStyles.userCard, children: [_jsxs("div", { className: lessonPageStyles.userCard__header, children: [_jsxs("p", { className: lessonPageStyles.userCard__header__number, children: ["\u2116:", index + 1] }), _jsx("p", { className: lessonPageStyles.userCard__header__username, children: item.fio }), _jsx(Button, { className: lessonPageStyles.userCard__header__button, size: ButtonSize.S, icon: _jsx(Eye, {}), onClick: function () {
                                                        navigate("/statistic/lesson/".concat(lessonId, "/steps?user=").concat((item.user_email), "&lesson=").concat(lesson.data.lesson.name));
                                                    } })] }), _jsxs("div", { className: lessonPageStyles.userCard__mainContent, children: [_jsxs("div", { className: lessonPageStyles.userCard__mainContent__stats, children: [_jsxs("div", { className: lessonPageStyles.userCard__mainContent__diagramWrapper, children: [_jsx("p", { className: lessonPageStyles.userCard__mainContent__diagramWrapper__title, children: "\u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441:" }), _jsx(Doughnut, { data: DoughnutData, options: DoughnutOptions }), _jsx("p", { className: lessonPageStyles.userCard__mainContent__diagramWrapper__percentage, children: "~%" })] }), _jsx("div", { className: lessonPageStyles.userCard__mainContent__progress, children: _jsx("p", { children: "0/100" }) })] }), _jsxs("div", { className: lessonPageStyles.userCard__mainContent__info, children: [_jsxs("p", { children: [_jsx("b", { children: "\u0413\u0440\u0443\u043F\u043F\u0430:" }), " ", item.club.name] }), _jsxs("p", { children: [_jsx("b", { children: "\u0423\u0440\u043E\u043A:" }), " ", lesson.data.lesson.name] }), _jsxs("p", { children: [_jsx("b", { children: "ID:" }), " ", item.bp_id] })] })] }), _jsxs("div", { className: lessonPageStyles.userCard__footer, children: [_jsxs("div", { className: lessonPageStyles.userCard__footer__first, children: [_jsxs("p", { children: ["\u041E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D: ", lesson.data.lesson.publish == 1 ? 'Да' : 'Нет'] }), _jsxs("p", { children: ["\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0435: ", item.current == 1 ? 'Да' : 'Нет'] })] }), _jsxs("div", { className: lessonPageStyles.userCard__footer__first, children: [_jsxs("p", { children: ["\u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043E: ", item.verified == 1 ? 'Да' : 'Нет'] }), _jsxs("p", { children: ["\u0414\u0430\u0442\u0430: ", (_h = (_g = (_f = (_e = item.finished_at) === null || _e === void 0 ? void 0 : _e.split(' ')[0]) === null || _f === void 0 ? void 0 : _f.split('-')) === null || _g === void 0 ? void 0 : _g.reverse()) === null || _h === void 0 ? void 0 : _h.join('.')] })] })] })] }, index)));
                            }) }), _jsx(ReactPaginate, { breakLabel: "...", nextLabel: ">", onPageChange: function (page) {
                                $api.post('/ext-course/frontend/manage/statistic/lesson', { lessonId: lessonId, page: page.selected + 1, limit: 100 })
                                    .then(function (d) { return setLesson(d.data); });
                            }, pageRangeDisplayed: 2, pageCount: (lesson.max - (lesson.max % 100)) / 100 + (lesson.max % 100 ? 1 : 0), previousLabel: "<", renderOnZeroPageCount: null, containerClassName: "pagination", pageClassName: "pagination__item", pageLinkClassName: "pagination__link", previousClassName: "pagination__item", previousLinkClassName: "pagination__link", nextClassName: "pagination__item", nextLinkClassName: "pagination__link" })] }))] }));
}
